import nameof from "ts-nameof.macro";
import { ObjectField } from "react3l-decorators";

import { Status } from "models/Status";
import { JobTitle } from "./JobTitle";

ObjectField(Status)(JobTitle.prototype, nameof(JobTitle.prototype.status));

export * from "./JobTitle";
export * from "./JobTitleFilter";
